const CARD_BRANDS = {
  visa: 'Visa',
  mastercard: 'Mastercard',
  mc: 'Mastercard',
  amex: 'American Express',
  americanexpress: 'American Express',
  discover: 'Discover',
  diners: 'Diners Club',
  dinersclub: 'Diners Club',
  jcb: 'JCB',
  unionpay: 'UnionPay',
  maestro: 'Maestro',
};

/** Processors report brands as lowercase codes (e.g. `visa`, `american_express`). */
export const formatCardBrand = (brand, fallback = 'Card') => {
  if (!brand || typeof brand !== 'string') return fallback;
  const key = brand.toLowerCase().replace(/[^a-z]/g, '');
  if (CARD_BRANDS[key]) return CARD_BRANDS[key];
  return brand
    .replace(/[_-]+/g, ' ')
    .trim()
    .replace(/\b\w/g, char => char.toUpperCase()) || fallback;
};

/** Masked numbers arrive as `425128******5128`, `************5128`, or `5128`. */
export const cardLastFour = (masked) => {
  const digits = String(masked ?? '').replace(/\D/g, '');
  return digits.length >= 4 ? digits.slice(-4) : null;
};
